import React from 'react';
import * as Sentry from "@sentry/react";
import { browserTracingIntegration } from "@sentry/browser";
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || "dev",
  enableLogs: true,
  debug: false,
  tracesSampleRate: 0.1,
  profilesSampleRate: 0.1,

  integrations: [
    browserTracingIntegration(),
  ],
});

root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
